import { API_URL } from '../../../app-config/constants';
import type { ReviewCycleDto } from '../../../types/ReviewCycleDto';
import { get, remove } from '../request';

const REVIEW_CYCLE_PATH = `${API_URL}/review-cycles/`;

type Query = {} | { onlyManageable: boolean };

getCycle.operation = 'READ';
export function getCycle(cycleId: string) {
    return get<ReviewCycleDto>(REVIEW_CYCLE_PATH + cycleId);
}

list.operation = 'READ';
export function list(query: Query = {}) {
    return get<ReviewCycleDto[]>(REVIEW_CYCLE_PATH, { getData: query });
}

deleteCycle.operation = 'DELETE';
export function deleteCycle(cycleId: string) {
    return remove(REVIEW_CYCLE_PATH + cycleId);
}

updateLaddaCache.operation = 'UPDATE';
export function updateLaddaCache(reviewCycle: ReviewCycleDto) {
    return Promise.resolve(reviewCycle);
}
